import { useEffect } from "react"

/* Protopia Ecosystem component */
export interface ICircleProps {
   id: string
   radius: number
}
const Circle = ({radius, ...props}: ICircleProps): JSX.Element => {
    useEffect(() => {
        const canvas: HTMLCanvasElement = document.getElementById( `circle-${props.id}` )! as HTMLCanvasElement
        const ctx : CanvasRenderingContext2D = canvas!.getContext("2d")! 
        ctx.beginPath()
        ctx.arc( radius + 2, radius + 2, radius, 0, 2 * Math.PI )
        ctx.lineWidth = .25
        ctx.strokeStyle = "var(--force-contrast-opacity-color)"
        ctx.stroke()
    })
    return <div 
        className='landing-figure-circle-container'
        style={{
            top: -10,
            left: -28,
            width: radius * 2 + 4,
            height: radius * 2 + 4,
            opacity: .5
        }}
    >
        <canvas 
            id={`circle-${props.id}`} 
            width={ radius * 2 + 4 }
            height={ radius * 2 + 4 }
        />
    </div>
}
export default Circle